import { CampaignType as TCampaignType } from "@/types/djangio"

const { CampaignType } = DjangIO.app.grassroots.campaign.types

export const transpileCampaignValueToCampaignType = (value: number): TCampaignType => {
    const campaignType = CampaignType.by_value(value)
    if (!campaignType) return {} as TCampaignType
    return campaignType as unknown as TCampaignType
}
